import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/workflows/user-workflows/{userWorkflowId}/tags']['PUT'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const updateUserWorkflowTags = async ({ userWorkflowId, tagText, tagIcon }: Input): Promise<Output> => {
  const response = await noodleApiClient.put(`/workflows/user-workflows/${userWorkflowId}/tags`, { tagIcon, tagText });
  return response.data;
};

export default updateUserWorkflowTags;
